import React, { ReactElement, useEffect, useRef, useState } from "react"
import { post, get } from "../../../netApi/fetch"

import { connect } from "react-redux"

import { Prompt } from "react-router-dom"
import { setLoginBindInfo } from "../../../reducers"

import BanUnLogin from "../../../high-component/BanUnLogin"
import Main from "../../../high-component/Content"
import { useHistory } from "react-router"
import styled from "styled-components"
import { confirm } from "../../Method/Confirm"
import imageUpload, { imageType } from "../../../methods/imageUpload"
import { Modal, Spin, message, Select, Segmented } from "antd"
import { PlayCircleOutlined, PauseCircleOutlined, RightOutlined } from "@ant-design/icons"
import { checkVideoQuota } from "../../../utils/quotaCheck"

// 定义类型
interface NoteType {
  id: string
  pid: string
  title: string
  content: string
  type: string
  image: string
  can_share: string
  show_read: string
  status: string
  createtime: string
  uid: string
  updatetime: string
  views: string
  comments: string
  reads: string
  sid: string
  images: imageType[]
  mp4?: {
    id: string
    url: string
    sound_url: string
    sound_id: string
    cover_url: string
    audio_status: string
    video_status: string
    cover_status: string
  }
  speech_recognition?: {
    id: string
    url: string
    text: string
  }
}

interface NoteComponentProps {
  note?: NoteType
  history: ReturnType<typeof useHistory>
  setLoginBindInfo?: (data: any) => void
  user?: any
  loginBindInfo?: any
}

const TitleInput = styled.input`
  font-size: 24px;
  font-weight: bold;
  border: none;
  border-bottom: 2px solid #eee;
  padding: 10px 0;
  width: 100%;
  margin-bottom: 20px;

  &:focus {
    outline: none;
    border-bottom-color: var(--theme-main);
  }
`

const ContentTextarea = styled.textarea`
  width: 100%;
  min-height: 300px;
  /* border: 1px solid rgb(240, 240, 240); */
  border: none;
  resize: none;
  border-radius: 8px;
  /* padding: 15px; */
  font-size: 16px;
  line-height: 1.6;
  /* resize: vertical; */

  &:focus {
    outline: none;
    border-color: var(--theme-main);
  }
`

const CreationDate = styled.p`
  color: grey;
  font-size: 14px;
  margin-bottom: 15px;
`

const RightPanel = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
`

const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`

const LoadingSpinner = styled.div`
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid var(--theme-main, #3498db);
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

// ===== styled 组件 =====
const ActionButton = styled.button`
  cursor: pointer;
  border-radius: 50vmin;
  background: var(--theme-main);
  color: #fff;
  padding: 8px 20px;
  font-size: 14px;
  border: none;
  font-weight: bold;
  &:hover {
    opacity: 0.8;
  }
`

const VideoList = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  margin-top: 12px;
  overflow-x: auto;
  overflow-y: hidden; /* 确保不出现垂直滚动条 */
  padding-bottom: 8px;
  scroll-behavior: smooth; /* 平滑滚动 */

  /* 确保滚动条样式 */
  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #aaa;
  }
`

const VideoItem = styled.div`
  position: relative;
  width: 150px;
  flex-shrink: 0; /* 防止项目被压缩 */
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition:
    transform 0.3s,
    box-shadow 0.3s;
  cursor: pointer;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  &.selected {
    border: 2px solid var(--theme-main);
  }
  &.selected::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 20px;
    z-index: 2;
    pointer-events: none;
  }
`

const LoadMoreButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 200px; /* 与视频高度一致 */
  flex-shrink: 0;
  border: 2px dashed #ddd;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s;
  background: #fafafa;

  &:hover {
    border-color: var(--theme-main);
    background: #f0f8ff;
    transform: translateY(-2px);
  }

  .load-more-icon {
    font-size: 24px;
    color: #666;
    transition: color 0.3s;
  }

  &:hover .load-more-icon {
    color: var(--theme-main);
  }
`

const VideoPlayer = styled.video`
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 12px;
  background: #000;
`

const VideoInfo = styled.div`
  padding: 12px;
  background: #fff;
`

const VideoTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const VideoTime = styled.div`
  font-size: 12px;
  color: #999;
  margin-bottom: 8px;
`

// 音频列表样式
const SoundList = styled.div`
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding: 12px 0;
  max-height: 140px;

  /* 滚动条样式 */
  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`

const SoundItem = styled.div`
  flex: 0 0 140px;
  border: 2px solid #e8e8e8;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;

  &:hover {
    border-color: #d0d0d0;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  &.selected {
    border-color: var(--theme-main);
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
  }
`

const SoundInfo = styled.div`
  padding: 6px 8px;
  background: #fff;
`

const SoundTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const SoundTime = styled.div`
  font-size: 12px;
  color: #999;
  margin-bottom: 8px;
`

const SoundLoadMoreButton = styled.div`
  flex: 0 0 80px;
  height: 100px;
  border: 2px dashed #d0d0d0;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #999;

  &:hover {
    border-color: var(--theme-main);
    color: var(--theme-main);

    .load-more-icon {
      transform: translateX(4px);
    }
  }

  .load-more-icon {
    font-size: 20px;
    transition: transform 0.3s ease;
  }
`

const ModalSection = styled.div`
  margin-bottom: 20px;
  text-align: left;
`

const GrayBox = styled.div`
  background: #f2f2f2;
  border-radius: 8px;
  padding: 16px;
  font-size: 14px;
  margin-top: 8px;
  max-width: 85%;
  min-width: 85%;
  float: left;
`

const TabButton = styled.button<{ active: boolean; disabled?: boolean }>`
  flex: 1;
  padding: 8px 12px;
  border: none;
  background: ${(props) => (props.disabled ? "#f5f5f5" : props.active ? "var(--theme-main)" : "#fff")};
  color: ${(props) => (props.disabled ? "#ccc" : props.active ? "#fff" : "#666")};
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: all 0.2s;
  white-space: nowrap;
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};

  &:hover {
    background: ${(props) => (props.disabled ? "#f5f5f5" : props.active ? "var(--theme-main)" : "#f5f5f5")};
  }
`

const GenerateButton = styled.button`
  width: 100%;
  padding: 12px 20px;
  background: var(--theme-main);
  color: #fff;
  border: none;
  border-radius: 50vmin;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: var(--theme-main-hover-light);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`

const GlobalStyle = styled.div`
  .version-segmented {
    .ant-segmented-item {
      border-radius: 50vmin !important;
      color: var(--theme-main) !important;
      font-weight: bold;
    }
    .ant-segmented-item-selected {
      background-color: var(--theme-main) !important;
      color: #fff !important;
    }
    .ant-segmented-thumb {
      border-radius: 50vmin !important;
      background-color: var(--theme-main) !important;
      box-shadow: none !important;
    }
  }
`

const _defaultState: NoteType = {
  id: "",
  pid: "",
  title: "",
  content: "",
  type: "1",
  image: "",
  can_share: "0",
  show_read: "0",
  status: "1",
  createtime: "",
  uid: "",
  updatetime: "",
  views: "0",
  comments: "0",
  reads: "0",
  sid: "",
  images: [],
}

const NoteEdit = (props): ReactElement => {
  const [noteData, setNoteData] = useState<NoteType>(_defaultState)
  const [images, setImages] = useState<imageType[]>([])
  const [isSaving, setIsSaving] = useState(false)
  const [isChanged, setIsChanged] = useState(false)
  const [loading, setLoading] = useState(false)

  const pid = props.match.params.id // 路由参数现在是pid
  const history = props.history
  // 地址栏参数
  const urlSearchParams = new URLSearchParams(props.location.search)
  const autoFocus = urlSearchParams.get("auto_focus") || ""
  const titleInputRef = useRef<HTMLInputElement>(null)
  const contentInputRef = useRef<HTMLTextAreaElement>(null)
  const imageInputRef = useRef<HTMLInputElement>(null)

  // Tab状态管理 - 需要在使用它的useEffect之前定义
  const [activeTab, setActiveTab] = useState(() => {
    const tabFromUrl = urlSearchParams.get("tab")
    return tabFromUrl || "audio"
  })

  const [modalVisible, setModalVisible] = useState(false)

  // 版本相关状态 - 从urls读取版本index
  const [versionList, setVersionList] = useState<NoteType[]>([])
  const [currentVersionIndex, setCurrentVersionIndex] = useState(() => {
    const versionFromUrl = urlSearchParams.get("version")
    return versionFromUrl ? parseInt(versionFromUrl) : -1 // -1表示还未加载
  })

  // AI生成相关状态
  const [aiQuestion, setAiQuestion] = useState("")
  const [aiGenerating, setAiGenerating] = useState(false)

  // const [urlSearchParamsImageDeleteId, setUrlSearchParamsImageDeleteId] = useState("")
  let urlSearchParamsImageDeleteId = ""
  useEffect(() => {
    switch (autoFocus) {
      case "title":
        titleInputRef.current?.focus()
        break
      case "content":
        contentInputRef.current?.focus()
        break
      case "image_delete":
        const id = urlSearchParams.get("id")
        if (!id) break
        // 只在第一次渲染的时候触发即可
        // eslint-disable-next-line react-hooks/exhaustive-deps
        urlSearchParamsImageDeleteId = id
        break
      case "image_add":
        imageInputRef.current?.click()
        break
      case "generatedVideo":
        // saveAndGenerate()
        break
    }
    // 重定向路由，防止刷新的时候重复触发
    if (autoFocus) {
      history.replace(`/index/contentedit/${pid}`)
    }
  }, [pid])

  // 同步版本到地址栏
  useEffect(() => {
    if (currentVersionIndex >= 0) {
      const currentParams = new URLSearchParams(props.location.search)
      const versionFromUrl = currentParams.get("version")
      if (versionFromUrl !== currentVersionIndex.toString()) {
        currentParams.set("version", currentVersionIndex.toString())
        history.replace(`${props.location.pathname}?${currentParams.toString()}`)
      }
    }
  }, [currentVersionIndex, history, props.location])

  // 同步tab到地址栏
  useEffect(() => {
    const currentParams = new URLSearchParams(props.location.search)
    const tabFromUrl = currentParams.get("tab")
    if (tabFromUrl !== activeTab) {
      currentParams.set("tab", activeTab)
      history.replace(`${props.location.pathname}?${currentParams.toString()}`)
    }
  }, [activeTab, history, props.location])

  // 声音模型
  const [soundText, setSoundText] = useState("")
  const [soundUrl, setSoundUrl] = useState("")
  const [soundId, setSoundId] = useState(null)
  const [isPlaying, setIsPlaying] = useState(false)
  const audioRef = React.useRef<HTMLAudioElement | null>(null)

  // 音频列表
  const [soundList, setSoundList] = useState<any[]>([])
  const [soundOffsetIndex, setSoundOffsetIndex] = useState(0)
  const [soundLength, setSoundLength] = useState(0)
  const [selectedSoundId, setSelectedSoundId] = useState<string | number | null>(null)
  const [soundLoading, setSoundLoading] = useState(false)
  const soundLimit = 5

  // 视频模型
  const [contentList, setContentList] = useState<any[]>([])
  const [viewOffsetIndex, setViewOffsetIndex] = useState(0)
  const [viewLength, setViewLength] = useState(0)
  const [selectedVideoId, setSelectedVideoId] = useState<string | number | null>(null)
  const [innerLoading, setInnerLoading] = useState(false)
  const limit = 5

  const [generating, setGenerating] = useState(false)
  const [generatedVideo, setGeneratedVideo] = useState<any>(null)
  const [generatedAudioId, setGeneratedAudioId] = useState<string | null>(null) // 保存生成的音频ID
  const [generatedAudioUrl, setGeneratedAudioUrl] = useState<string | null>(null) // 保存生成的音频URL
  const [generatedCoverUrl, setGeneratedCoverUrl] = useState<string | null>(null) // 保存生成的封面URL
  const [playbackRate, setPlaybackRate] = useState(1.5)
  const videoRef = React.useRef<HTMLVideoElement>(null)
  const generatedAudioRef = React.useRef<HTMLAudioElement>(null)

  // 获取音频列表
  const handleGetSoundList = (reset = false) => {
    // 只在首次加载时显示loading动画
    if (reset) setSoundLoading(true)
    const offset = reset ? 0 : soundOffsetIndex * soundLimit
    get(`/ip/viewmp3list?offset=${offset}&limit=${soundLimit}`, {}).then((res) => {
      console.log("ip/viewmp3list?offset :>> ", res)

      // 音频接口现在返回 { count, list } 格式
      const soundArray = res.list || []

      if (reset) {
        setSoundList(soundArray)
        setSoundOffsetIndex(1)
        setSoundLength(res.count || 0)
      } else {
        setSoundList([...soundList, ...soundArray])
        setSoundOffsetIndex(soundOffsetIndex + 1)
        setSoundLength(res.count || 0)
      }

      if (soundArray.length > 0 && !selectedSoundId) {
        setSelectedSoundId(soundArray[0].id)
      }
      // 只在首次加载完成时关闭loading
      if (reset) setSoundLoading(false)
    })
  }

  const fetchSoundModel = () => {
    setSoundText("看着窗外缓缓下落的雨滴，滴答声成了最好的背景音乐，拿起笔，写下了心中的所思所想，雨天也有独特的韵味。")
    setSoundUrl("")
    // 改为获取音频列表
    handleGetSoundList(true)

    // 保持原有的单个音频获取（可能用于播放）
    get("/ip/viewmp3", {})
      .then((res) => {
        console.log("fetchSoundModel :>> ", res)
        setSoundUrl(res.url || "")
        setSoundId(res.id || null)
      })
      .catch(() => {
        setSoundText("音频加载失败")
        setSoundUrl("")
      })
  }
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    fetchSoundModel()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  // 加载内容数据
  const loadContentData = (pidParam: string) => {
    if (pidParam === "-1") return
    setLoading(true)
    get("/content/viewwithpid", { pid: pidParam })
      .then((res) => {
        if (res.list && res.list.length > 0) {
          setVersionList(res.list)

          // 如果 URL 中没有指定版本，默认选择最后一个（最旧的版本）
          const versionFromUrl = urlSearchParams.get("version")
          const defaultIndex = versionFromUrl ? parseInt(versionFromUrl) : res.list.length - 1
          setCurrentVersionIndex(defaultIndex)

          const latestVersion = res.list[defaultIndex] || res.list[0]
          setNoteData(latestVersion)
          setImages(latestVersion.images?.filter((image) => image.id !== urlSearchParamsImageDeleteId) || [])

          // 处理已生成的资源
          if (latestVersion.mp4) {
            const mp4 = latestVersion.mp4

            // 处理音频状态
            if (mp4.audio_status === "1" && mp4.sound_url) {
              // 音频已生成
              setGeneratedAudioUrl(mp4.sound_url)
              setGeneratedAudioId(mp4.sound_id)
            } else if (mp4.audio_status === "2") {
              // 音频生成中
              console.log("音频生成中...")
              // TODO: 可以添加轮询逻辑
            } else {
              // 清空音频数据
              setGeneratedAudioUrl(null)
              setGeneratedAudioId(null)
            }

            // 处理视频状态
            if (mp4.video_status === "1" && mp4.url) {
              // 视频已生成
              setGeneratedVideo(mp4.url)
            } else if (mp4.video_status === "2") {
              // 视频生成中
              console.log("视频生成中...")
              // TODO: 可以添加轮询逻辑
            } else {
              // 清空视频数据
              setGeneratedVideo(null)
            }

            // 处理封面状态
            if (mp4.cover_status === "1" && mp4.cover_url) {
              // 封面已生成
              setGeneratedCoverUrl(mp4.cover_url)
            } else if (mp4.cover_status === "2") {
              // 封面生成中
              console.log("封面生成中...")
              // TODO: 可以添加轮询逻辑
            } else {
              // 清空封面数据
              setGeneratedCoverUrl(null)
            }
          } else {
            // 没有mp4数据，清空所有生成的资源
            setGeneratedAudioUrl(null)
            setGeneratedAudioId(null)
            setGeneratedVideo(null)
            setGeneratedCoverUrl(null)
          }
        }
      })
      .catch((err) => {
        if (err.code !== 0) {
          setModalVisible(false)
          confirm({ text: err.message || "获取笔记失败" }).then(() => {
            history.goBack()
          })
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    loadContentData(pid)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pid, urlSearchParamsImageDeleteId])

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNoteData({ ...noteData, title: e.target.value })
    setIsChanged(true)
  }

  const handleContentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setNoteData({ ...noteData, content: e.target.value })
    setIsChanged(true)
  }

  const handleImageDelete = (id: string): void => {
    setImages((images) => images?.filter((image) => image.id !== id) || [])
    setIsChanged(true)
  }

  const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    // if (e.target.files && e.target.files[0]) {
    //   const file = e.target.files[0]
    //   const reader = new FileReader()

    //   reader.onload = (event) => {
    //     if (event.target && typeof event.target.result === "string") {
    //       setImages([...images, event.target.result])
    //       setIsChanged(true)
    //     }
    //   }

    //   reader.readAsDataURL(file)
    // }
    for (let i = 0; i < e.target.files.length; i++) {
      const file = e.target.files[i]
      imageUpload(file, "content").then((res) => {
        console.log("res :>> ", res)
        setImages((lst) => [...lst, res])
        setIsChanged(true)
      })
    }
  }

  // 保存逻辑，isClick: true=仅保存，false=保存并生成视频
  const handleSave = async (isClick = true): Promise<boolean> => {
    if (!noteData.content.trim()) {
      confirm({ text: "请输入内容" })
      return false
    }
    if (isChanged === false) {
      if (isClick) confirm({ text: "没有任何修改，无需保存" })
      return !isClick // 用户点击保存时视为错误，自动保存时无更改不视为错误
    }
    setIsSaving(true)
    try {
      if (pid === "-1") {
        // 新建
        const result = await post("/content/create?app=jieligo", {
          title: noteData.title,
          content: noteData.content,
          type: 1,
          image: images.map((i) => i.id).join(",") ?? "",
          imageids: images.map((i) => i.id),
        })
        setIsChanged(false)
        isClick &&
          confirm({ text: "保存成功" }).then(() => {
            // 跳转到查看页面
            history.replace(`/index/content/${result.pid}`)
          })
        return true
      } else {
        // 编辑
        const updateData = {
          id: noteData.id,
          pid: noteData.pid,
          title: noteData.title,
          content: noteData.content,
          imageids: images.map((img) => img.id),
          sid: noteData.sid || "",
        }
        await post("/content/update", updateData)
        setIsChanged(false)

        // 重新加载版本列表
        await loadContentData(noteData.pid)

        isClick &&
          confirm({ text: "保存成功" }).then(() => {
            // 跳转到查看页面
            history.replace(`/index/content/${updateData.pid}`)
          })
        return true
      }
    } catch (error) {
      console.error("保存失败:", error)
      confirm({ text: "保存失败，请重试" })
      return false
    } finally {
      setIsSaving(false)
    }
  }

  const handleCancel = () => {
    // history.push(`/content/${pageId}`)
    history.goBack()
    // if (isChanged) {
    //   confirm({
    //     text: "确定要放弃修改吗？",
    //   }).then((res) => {
    //     if (res) {
    //       history.goBack()
    //     }
    //   })
    // } else {
    //   history.goBack()
    // }
  }

  const handleGetContentList = (reset = false) => {
    if (reset) setInnerLoading(true) // innerLoading 不是全屏加载
    const offset = reset ? 0 : viewOffsetIndex * limit
    get(`/ip/viewmp4list?offset=${offset}&limit=${limit}`, {}).then((res) => {
      setViewLength(res.count || 10)
      if (reset) {
        setContentList(res.list || [])
        setViewOffsetIndex(1)
      } else {
        setContentList([...contentList, ...(res.list || [])])
        setViewOffsetIndex(viewOffsetIndex + 1)
      }
      if (res.list.length > 0 && !selectedVideoId) {
        setSelectedVideoId(res.list[0].id)
      }
      if (reset) setInnerLoading(false)
    })
  }
  // 保存并生成视频 - 已弃用，现在保存后直接跳转到view页面
  // const saveAndGenerate = async () => {
  //   if (isChanged) {
  //     // 有修改，先保存
  //     const result = await handleSave(false)
  //     if (!result) return
  //     // 新建时 handleSave 已经跳转并带 auto_focus=generatedVideo
  //     if (pageId === "-1") return
  //   }
  //   if (pageId === "-1" && !noteData.content.trim()) {
  //     confirm({ text: "请输入内容" })
  //     return
  //   }

  //   // 检查配额（首次免费用户会显示提醒弹窗）
  //   const canGenerate = await checkVideoQuota()
  //   if (!canGenerate) {
  //     return
  //   }

  //   // 没有修改，或编辑保存后，弹出生成视频弹窗
  //   handleGetContentList(true)
  //   setModalVisible(true)
  // }

  const handleDelete = () => {
    confirm({
      text: "确定要删除吗？",
    }).then((res) => {
      if (res) {
        post("/content/deletepid", { pid: noteData.pid }).then(() => {
          localStorage.setItem("restore_content_edit_cache", "1")
          localStorage.setItem("refresh_content_id", noteData.id)
          localStorage.setItem("refresh_content_pid", noteData.pid || noteData.id)
          history.push("/")
        })
      }
    })
  }

  const togglePlay = () => {
    if (!audioRef.current || !soundUrl) return
    if (isPlaying) {
      audioRef.current.pause()
    } else {
      audioRef.current.play()
    }
    setIsPlaying(!isPlaying)
  }

  const handleGenerateVideo = async () => {
    if (!selectedVideoId) {
      message.warning("请选择视频模型")
      return
    }

    // 检查是否已有音频
    if (!generatedAudioUrl) {
      message.warning("请先生成音频")
      return
    }

    setGenerating(true)
    setModalVisible(false)

    let currentContentId = noteData.id

    // 使用生成的音频来制作视频（audioType=generated时不需要audioId）
    post("/ip/generatevideo", {
      contentId: currentContentId,
      videoId: selectedVideoId,
      audioType: "generated",
    })
      .then((res) => {
        setGenerating(false)
        message.success("AI视频生成成功！")

        // 更新contentId（可能是新复制的）
        if (res.contentId && res.contentId !== currentContentId) {
          setNoteData({ ...noteData, id: res.contentId })
          history.replace(`/index/index/contentedit/${res.pid}`)
          // 重新加载数据
          loadContentData(res.contentId)
        } else {
          setGeneratedVideo(res.videoUrl)
          // 自动切换到视频tab
          setActiveTab("video")
        }
      })
      .catch((err) => {
        setGenerating(false)
        if (!err) err = "生成失败"
        message.error(err.data || err.message || err)
      })
  }

  // 处理生成按钮点击 - 已弃用，现在保存后直接跳转到view页面
  // const handleGenerate = async () => {
  //   // 先保存内容
  //   const saveSuccess = await handleSave(false)
  //   if (!saveSuccess) {
  //     message.error("请先保存内容")
  //     return
  //   }

  //   switch (activeTab) {
  //     case "audio":
  //       // 打开音频选择弹窗
  //       handleGetSoundList(true)
  //       setModalVisible(true)
  //       break
  //     case "video":
  //       // 打开视频选择弹窗（不需要音频模型）
  //       handleGetContentList(true)
  //       setModalVisible(true)
  //       break
  //     case "cover":
  //       // 直接调用生成封面API
  //       handleGenerateCover()
  //       break
  //     case "all":
  //       // 打开全部生成弹窗（音频+视频）
  //       handleGetSoundList(true)
  //       handleGetContentList(true)
  //       setModalVisible(true)
  //       break
  //   }
  // }

  // 生成音频
  const handleGenerateAudio = () => {
    if (!selectedSoundId) {
      message.warning("请选择音频模型")
      return
    }
    setGenerating(true)
    setModalVisible(false)

    post("/ip/generateaudio", {
      contentId: noteData.id,
      soundId: selectedSoundId,
    })
      .then((res) => {
        setGenerating(false)
        message.success("AI音频生成成功！")

        // 更新contentId（可能是新复制的）
        if (res.contentId && res.contentId !== noteData.id) {
          setNoteData({ ...noteData, id: res.contentId })
          history.replace(`/contentedit/${res.pid}`)
          // 重新加载数据
          loadContentData(res.contentId)
        } else {
          // 保存生成的音频ID和URL
          setGeneratedAudioId(res.audioId)
          setGeneratedAudioUrl(res.audioUrl)
          // 自动切换到音频tab
          setActiveTab("audio")
        }
      })
      .catch((err) => {
        setGenerating(false)
        if (!err) err = "生成失败"
        message.error(err.data || err.message || err)
      })
  }

  // 生成封面
  const handleGenerateCover = () => {
    setGenerating(true)

    post("/ip/generatecover", {
      contentId: noteData.id,
    })
      .then((res) => {
        setGenerating(false)
        message.success("封面生成成功！")

        // 更新contentId（可能是新复制的）
        if (res.contentId && res.contentId !== noteData.id) {
          setNoteData({ ...noteData, id: res.contentId })
          history.replace(`/index/contentedit/${res.pid}`)
          // 重新加载数据
          loadContentData(res.contentId)
        } else {
          // 保存生成的封面URL
          setGeneratedCoverUrl(res.coverUrl)
          // 自动切换到封面tab
          setActiveTab("cover")
        }
      })
      .catch((err) => {
        setGenerating(false)
        if (!err) err = "生成失败"
        message.error(err.data || err.message || err)
      })
  }

  // AI生成笔记内容
  const handleAIGenerate = async () => {
    if (!aiQuestion.trim()) {
      message.warning("请输入问题或指令")
      return
    }

    // 先保存当前内容
    if (isChanged) {
      const saveSuccess = await handleSave(false)
      if (!saveSuccess) {
        message.error("保存失败，无法继续生成")
        return
      }
    }

    setAiGenerating(true)

    try {
      // 基于当前content.id生成
      const res = await post("/content/contentai", {
        question: aiQuestion,
        contentId: noteData.id,
      })

      setAiGenerating(false)
      message.success("AI内容生成成功！")

      // 刷新版本列表
      if (res.pid) {
        localStorage.setItem("refresh_content_pid", res.pid)
        localStorage.setItem("refresh_content_id", res.id)
        // 重新加载版本列表
        loadContentData(res.pid)
        // 切换到新生成的版本（index 0是最新的）
        setCurrentVersionIndex(0)
      }

      // 清空输入框
      setAiQuestion("")
    } catch (err: any) {
      setAiGenerating(false)
      message.error(err.data || err.message || "AI生成失败")
    }
  }

  // 生成全部
  const handleGenerateAll = () => {
    if (!selectedSoundId || !selectedVideoId) {
      message.warning("请选择音频和视频模型")
      return
    }
    setGenerating(true)
    setModalVisible(false)

    post("/ip/generateall", {
      contentId: noteData.id,
      soundId: selectedSoundId,
      videoId: selectedVideoId,
    })
      .then((res) => {
        setGenerating(false)
        message.success("全部内容生成成功！")

        // 更新contentId（可能是新复制的）
        if (res.contentId && res.contentId !== noteData.id) {
          setNoteData({ ...noteData, id: res.contentId })
          history.replace(`/index/contentedit/${res.pid}`)
          // 重新加载数据
          loadContentData(res.contentId)
        } else {
          // 保存生成的所有资源
          setGeneratedAudioId(res.audioId)
          setGeneratedAudioUrl(res.audioUrl)
          setGeneratedVideo(res.videoUrl)
          setGeneratedCoverUrl(res.coverUrl)
          // 自动切换到封面tab
          setActiveTab("cover")
        }
      })
      .catch((err) => {
        setGenerating(false)
        if (!err) err = "生成失败"
        message.error(err.data || err.message || err)
      })
  }

  // const isLogin = props.user?.uid
  // if (!isLogin) {
  //   alert("请先登入")
  //   return <Redirect to="/login" />
  // }
  // console.log("object :>> ", noteData.sid, props.user?.sid )
  // if (noteData.sid !== props.user?.sid) {
  //   alert("你没有编辑权限")
  //   props.history.goBack()
  //   return <></>
  // }
  return (
    <>
      <GlobalStyle>
        {loading && (
          <LoadingOverlay>
            <LoadingSpinner />
          </LoadingOverlay>
        )}
        <div
          style={{
            maxWidth: "1400px",
            position: "relative",
            width: "100%",
            minWidth: "300px",
            margin: "0 auto",
            minHeight: "100vh",
            padding: "0 20px 40px",
            marginTop: "-30px",
          }}
        >
          {/* 主要内容区域 - 使用flex布局 */}
          <div
            style={{
              display: "flex",
              gap: "20px",
              alignItems: "flex-start",
              flexDirection: window.innerWidth > 768 ? "row" : "column",
            }}
          >
            {/* 左侧主编辑区域 */}
            <div style={{ flex: 1, minWidth: 0, position: "relative" }}>
              <Prompt when={isChanged} message="您有未保存的修改，确定要离开吗？" />

              {/* AI生成时的遮罩 */}
              {aiGenerating && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "rgba(255, 255, 255, 0.85)",
                    backdropFilter: "blur(2px)",
                    borderRadius: "20px",
                    zIndex: 10,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    <LoadingSpinner style={{ margin: "0 auto 16px" }} />
                    <div style={{ fontSize: "16px", fontWeight: "600", color: "#333", marginBottom: "8px" }}>AI生成中...</div>
                    <div style={{ fontSize: "14px", color: "#666" }}>正在为您生成内容，请稍候</div>
                  </div>
                </div>
              )}

              <div
                style={{
                  padding: "20px 30px",
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  minHeight: "400px",
                }}
              >
                {/* 顶部按钮组 */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px", gap: "16px" }}>
                  <div
                    style={{
                      cursor: "pointer",
                      fontSize: "14px",
                      color: "#666",
                      padding: "8px 16px",
                      borderRadius: "50vmin",
                      border: "1px solid #e0e0e0",
                      transition: "all 0.3s",
                    }}
                    onClick={() => handleCancel()}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.borderColor = "var(--theme-main)"
                      e.currentTarget.style.color = "var(--theme-main)"
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.borderColor = "#e0e0e0"
                      e.currentTarget.style.color = "#666"
                    }}
                  >
                    ← 返回
                  </div>

                  {versionList.length > 1 && (
                    <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
                      <Segmented
                        className="version-segmented"
                        value={currentVersionIndex}
                        onChange={async (value) => {
                          const newIndex = value as number
                          if (newIndex === currentVersionIndex) return

                          // 如果有未保存的修改，提示保存
                          if (isChanged) {
                            const shouldSave = await confirm({
                              text: "您有未保存的修改，是否保存后切换版本？",
                            })
                            if (shouldSave) {
                              const saveSuccess = await handleSave(false)
                              if (!saveSuccess) return
                            }
                          }

                          const selectedVersion = versionList[newIndex]
                          setCurrentVersionIndex(newIndex)
                          setNoteData(selectedVersion)
                          setImages(selectedVersion.images || [])
                          setIsChanged(false)
                        }}
                        options={versionList.map((_, index) => ({
                          label: `版本${index + 1}`,
                          value: index,
                        }))}
                        style={{
                          borderRadius: "50vmin",
                          padding: "4px",
                        }}
                      />
                    </div>
                  )}
                  <div style={{ display: "flex", gap: "10px" }}>
                    <button
                      onClick={() => handleDelete()}
                      style={{
                        backgroundColor: "#fff",
                        color: "#e74c3c",
                        border: "1px solid #e74c3c",
                        padding: "8px 16px",
                        borderRadius: "50vmin",
                        fontSize: "14px",
                        cursor: "pointer",
                        fontWeight: "500",
                        transition: "all 0.3s",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#e74c3c"
                        e.currentTarget.style.color = "#fff"
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "#fff"
                        e.currentTarget.style.color = "#e74c3c"
                      }}
                    >
                      删除笔记
                    </button>
                    <button
                      onClick={() => handleSave()}
                      disabled={isSaving}
                      style={{
                        backgroundColor: "var(--theme-main)",
                        color: "#fff",
                        border: "none",
                        padding: "8px 16px",
                        borderRadius: "50vmin",
                        fontSize: "14px",
                        cursor: isSaving ? "not-allowed" : "pointer",
                        opacity: isSaving ? 0.6 : 1,
                        fontWeight: "500",
                      }}
                    >
                      {isSaving ? "保存中..." : "保存"}
                    </button>
                  </div>
                </div>
                <TitleInput placeholder="请输入标题" value={noteData.title} onChange={handleTitleChange} ref={titleInputRef} />

                <CreationDate>创建于：{noteData.createtime}</CreationDate>

                {/* <ImagesContainer className="images">
                {images.map((image, index) => (
                  <ImageItem key={index} className="image">
                    <img src={image.url} alt="" />
                    <span className="delete-image" onClick={() => handleImageDelete(image.id)}>
                      ×
                    </span>
                  </ImageItem>
                ))}

                <ImageUploadButton>
                  <i className="iconfont icon-plus" style={{ fontSize: "24px", marginBottom: "5px" }}></i>
                  <span>添加图片</span>
                  <input type="file" accept="image/*" onChange={handleImageUpload} ref={imageInputRef} />
                </ImageUploadButton>
              </ImagesContainer> */}

                <ContentTextarea placeholder="请输入内容..." value={noteData.content} onChange={handleContentChange} ref={contentInputRef} />

                {/* 底部AI输入框区域 */}
                <div style={{ marginTop: "30px", paddingTop: "20px", borderTop: "1px solid #f0f0f0" }}>
                  <div style={{ position: "relative" }}>
                    <textarea
                      value={aiQuestion}
                      onChange={(e) => setAiQuestion(e.target.value)}
                      placeholder="随便问点什么"
                      disabled={aiGenerating}
                      style={{
                        width: "100%",
                        minHeight: "80px",
                        padding: "12px",
                        paddingRight: "80px",
                        border: "1px solid #e0e0e0",
                        borderRadius: "8px",
                        fontSize: "14px",
                        resize: "vertical",
                        outline: "none",
                        transition: "border-color 0.3s",
                        opacity: aiGenerating ? 0.6 : 1,
                      }}
                      onFocus={(e) => (e.currentTarget.style.borderColor = "var(--theme-main)")}
                      onBlur={(e) => (e.currentTarget.style.borderColor = "#e0e0e0")}
                    />
                    <button
                      onClick={handleAIGenerate}
                      disabled={!aiQuestion.trim() || aiGenerating}
                      style={{
                        position: "absolute",
                        right: "8px",
                        bottom: "8px",
                        padding: "8px 16px",
                        backgroundColor: !aiQuestion.trim() || aiGenerating ? "#ccc" : "var(--theme-main)",
                        color: "#fff",
                        border: "none",
                        borderRadius: "50vmin",
                        fontSize: "13px",
                        fontWeight: "600",
                        cursor: !aiQuestion.trim() || aiGenerating ? "not-allowed" : "pointer",
                        transition: "all 0.3s",
                      }}
                      onMouseEnter={(e) => {
                        if (!aiQuestion.trim() || aiGenerating) return
                        e.currentTarget.style.backgroundColor = "var(--theme-main-hover-light)"
                        e.currentTarget.style.transform = "translateY(-1px)"
                        e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.15)"
                      }}
                      onMouseLeave={(e) => {
                        if (!aiQuestion.trim() || aiGenerating) return
                        e.currentTarget.style.backgroundColor = "var(--theme-main)"
                        e.currentTarget.style.transform = "none"
                        e.currentTarget.style.boxShadow = "none"
                      }}
                    >
                      {aiGenerating ? "生成中..." : "发送"}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* 右侧面板 */}
            <div
              style={{
                width: window.innerWidth > 768 ? "420px" : "100%",
                flexShrink: 0,
              }}
            >
              <RightPanel
                style={{
                  height: "fit-content",
                  position: "sticky",
                  top: "20px",
                }}
              >
                {/* Tab 切换栏 */}
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    marginBottom: "20px",
                    borderBottom: "2px solid #f0f0f0",
                    paddingBottom: "8px",
                  }}
                >
                  <TabButton active={activeTab === "audio"} onClick={() => !generating && setActiveTab("audio")} disabled={generating}>
                    生成音频
                  </TabButton>
                  <TabButton active={activeTab === "video"} onClick={() => !generating && setActiveTab("video")} disabled={generating}>
                    生成视频
                  </TabButton>
                  <TabButton active={activeTab === "cover"} onClick={() => !generating && setActiveTab("cover")} disabled={generating}>
                    生成封面
                  </TabButton>
                  <TabButton active={activeTab === "all"} onClick={() => !generating && setActiveTab("all")} disabled={generating}>
                    全部生成
                  </TabButton>
                </div>

                {/* Tab 内容区域 */}
                <Spin
                  spinning={generating || aiGenerating}
                  tip={
                    aiGenerating
                      ? "AI生成中..."
                      : activeTab === "audio"
                        ? "音频生成中..."
                        : activeTab === "video"
                          ? "视频生成中..."
                          : activeTab === "cover"
                            ? "封面生成中..."
                            : activeTab === "all"
                              ? "全部内容生成中..."
                              : "处理中..."
                  }
                  size="large"
                >
                  <div style={{ minHeight: "260px", marginBottom: "16px" }}>
                    {activeTab === "audio" &&
                      (generating && !generatedAudioUrl ? (
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "60px 20px" }}>
                          <LoadingSpinner />
                          <div style={{ marginTop: "20px", fontSize: "14px", color: "#666" }}>音频生成中...</div>
                        </div>
                      ) : generatedAudioUrl ? (
                        <div>
                          <div
                            style={{
                              background: "#f5f5f5",
                              borderRadius: "12px",
                              padding: "20px",
                              marginBottom: "12px",
                            }}
                          >
                            <div style={{ fontSize: "14px", color: "#666", marginBottom: "12px" }}>生成的音频</div>
                            <audio ref={generatedAudioRef} controls style={{ width: "100%" }} src={generatedAudioUrl} />
                          </div>
                          <button
                            onClick={() => {
                              window.open(generatedAudioUrl, "_blank")
                            }}
                            style={{
                              width: "100%",
                              padding: "10px 20px",
                              backgroundColor: "#fff",
                              color: "var(--theme-main)",
                              border: "1px solid var(--theme-main)",
                              borderRadius: "50vmin",
                              fontSize: "14px",
                              fontWeight: "500",
                              cursor: "pointer",
                              transition: "all 0.3s",
                            }}
                            onMouseEnter={(e) => {
                              const target = e.target as HTMLButtonElement
                              target.style.backgroundColor = "var(--theme-main)"
                              target.style.color = "#fff"
                            }}
                            onMouseLeave={(e) => {
                              const target = e.target as HTMLButtonElement
                              target.style.backgroundColor = "#fff"
                              target.style.color = "var(--theme-main)"
                            }}
                          >
                            下载音频
                          </button>
                        </div>
                      ) : (
                        <div style={{ textAlign: "center", padding: "40px 20px" }}>
                          <div
                            style={{
                              width: 80,
                              height: 80,
                              background: "#f2f6fa",
                              borderRadius: "16px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginBottom: 16,
                              margin: "0 auto 16px",
                            }}
                          >
                            <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="48.000000" height="48.000000" fill="none">
                              <defs>
                                <image id="image_audio" width="200.000000" height="200.000000" xlinkHref={require("../../../images/mp4Default.png")} />
                                <pattern id="pattern_audio" width="1.000000" height="1.000000" patternContentUnits="objectBoundingBox">
                                  <use transform="matrix(0.005,0,0,0.005,0,0)" xlinkHref="#image_audio" />
                                </pattern>
                              </defs>
                              <rect width="200.000000" height="200.000000" x="0.000000" y="0.000000" fill="url(#pattern_audio)" />
                            </svg>
                          </div>
                          <div style={{ fontSize: 16, fontWeight: 500, marginBottom: 8, color: "#666" }}>生成AI音频</div>
                          <div style={{ fontSize: 14, color: "#999" }}>将文字转换为自然流畅的语音</div>
                        </div>
                      ))}

                    {activeTab === "video" &&
                      (generating && !generatedVideo ? (
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "60px 20px" }}>
                          <LoadingSpinner />
                          <div style={{ marginTop: "20px", fontSize: "14px", color: "#666" }}>视频生成中...</div>
                        </div>
                      ) : generatedVideo ? (
                        <div>
                          <video
                            controls
                            ref={videoRef}
                            onLoadedMetadata={() => {
                              if (videoRef.current) {
                                videoRef.current.playbackRate = playbackRate
                              }
                            }}
                            style={{
                              width: "100%",
                              maxHeight: "400px",
                              objectFit: "contain",
                              borderRadius: "12px",
                              background: "#000",
                            }}
                          >
                            <source src={generatedVideo} />
                            您的浏览器不支持视频播放
                          </video>
                          <div style={{ display: "flex", alignItems: "center", marginTop: "8px", marginBottom: "4px" }}>
                            <span style={{ marginRight: "8px", fontSize: "14px", color: "#666" }}>播放速度：</span>
                            <Select
                              value={playbackRate}
                              onChange={(value) => {
                                setPlaybackRate(value)
                                if (videoRef.current) {
                                  videoRef.current.playbackRate = value
                                }
                              }}
                              style={{ width: 120 }}
                              size="small"
                            >
                              <Select.Option value={0.5}>0.5x</Select.Option>
                              <Select.Option value={0.75}>0.75x</Select.Option>
                              <Select.Option value={1}>1x</Select.Option>
                              <Select.Option value={1.25}>1.25x</Select.Option>
                              <Select.Option value={1.5}>1.5x</Select.Option>
                              <Select.Option value={1.75}>1.75x</Select.Option>
                              <Select.Option value={2}>2x</Select.Option>
                            </Select>
                          </div>
                          <button
                            onClick={() => {
                              window.open(generatedVideo, "_blank")
                            }}
                            style={{
                              width: "100%",
                              marginTop: "12px",
                              padding: "10px 20px",
                              backgroundColor: "#fff",
                              color: "var(--theme-main)",
                              border: "1px solid var(--theme-main)",
                              borderRadius: "50vmin",
                              fontSize: "14px",
                              fontWeight: "500",
                              cursor: "pointer",
                              transition: "all 0.3s",
                            }}
                            onMouseEnter={(e) => {
                              const target = e.target as HTMLButtonElement
                              target.style.backgroundColor = "var(--theme-main)"
                              target.style.color = "#fff"
                            }}
                            onMouseLeave={(e) => {
                              const target = e.target as HTMLButtonElement
                              target.style.backgroundColor = "#fff"
                              target.style.color = "var(--theme-main)"
                            }}
                          >
                            下载视频
                          </button>
                        </div>
                      ) : (
                        <div style={{ textAlign: "center", padding: "40px 20px" }}>
                          <div
                            style={{
                              width: 80,
                              height: 80,
                              background: "#f2f6fa",
                              borderRadius: "16px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginBottom: 16,
                              margin: "0 auto 16px",
                            }}
                          >
                            <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="48.000000" height="48.000000" fill="none">
                              <defs>
                                <image id="image_video" width="200.000000" height="200.000000" xlinkHref={require("../../../images/mp4Default.png")} />
                                <pattern id="pattern_video" width="1.000000" height="1.000000" patternContentUnits="objectBoundingBox">
                                  <use transform="matrix(0.005,0,0,0.005,0,0)" xlinkHref="#image_video" />
                                </pattern>
                              </defs>
                              <rect width="200.000000" height="200.000000" x="0.000000" y="0.000000" fill="url(#pattern_video)" />
                            </svg>
                          </div>
                          <div style={{ fontSize: 16, fontWeight: 500, marginBottom: 8, color: "#666" }}>生成AI视频</div>
                          <div style={{ fontSize: 14, color: "#999" }}>确认要表达的文字后即可生成</div>
                        </div>
                      ))}

                    {activeTab === "cover" &&
                      (generating && !generatedCoverUrl ? (
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "60px 20px" }}>
                          <LoadingSpinner />
                          <div style={{ marginTop: "20px", fontSize: "14px", color: "#666" }}>封面生成中...</div>
                        </div>
                      ) : generatedCoverUrl ? (
                        <div>
                          <div
                            style={{
                              background: "#f5f5f5",
                              borderRadius: "12px",
                              overflow: "hidden",
                              marginBottom: "12px",
                              maxHeight: "400px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <img
                              src={generatedCoverUrl}
                              alt="生成的封面"
                              style={{
                                width: "100%",
                                maxHeight: "400px",
                                display: "block",
                                objectFit: "contain",
                              }}
                            />
                          </div>
                          <button
                            onClick={() => {
                              window.open(generatedCoverUrl, "_blank")
                            }}
                            style={{
                              width: "100%",
                              padding: "10px 20px",
                              backgroundColor: "#fff",
                              color: "var(--theme-main)",
                              border: "1px solid var(--theme-main)",
                              borderRadius: "50vmin",
                              fontSize: "14px",
                              fontWeight: "500",
                              cursor: "pointer",
                              transition: "all 0.3s",
                            }}
                            onMouseEnter={(e) => {
                              const target = e.target as HTMLButtonElement
                              target.style.backgroundColor = "var(--theme-main)"
                              target.style.color = "#fff"
                            }}
                            onMouseLeave={(e) => {
                              const target = e.target as HTMLButtonElement
                              target.style.backgroundColor = "#fff"
                              target.style.color = "var(--theme-main)"
                            }}
                          >
                            下载封面
                          </button>
                        </div>
                      ) : (
                        <div style={{ textAlign: "center", padding: "40px 20px" }}>
                          <div
                            style={{
                              width: 80,
                              height: 80,
                              background: "#f2f6fa",
                              borderRadius: "16px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginBottom: 16,
                              margin: "0 auto 16px",
                            }}
                          >
                            <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="48.000000" height="48.000000" fill="none">
                              <defs>
                                <image id="image_cover" width="200.000000" height="200.000000" xlinkHref={require("../../../images/mp4Default.png")} />
                                <pattern id="pattern_cover" width="1.000000" height="1.000000" patternContentUnits="objectBoundingBox">
                                  <use transform="matrix(0.005,0,0,0.005,0,0)" xlinkHref="#image_cover" />
                                </pattern>
                              </defs>
                              <rect width="200.000000" height="200.000000" x="0.000000" y="0.000000" fill="url(#pattern_cover)" />
                            </svg>
                          </div>
                          <div style={{ fontSize: 16, fontWeight: 500, marginBottom: 8, color: "#666" }}>生成封面图</div>
                          <div style={{ fontSize: 14, color: "#999" }}>根据标题和内容生成精美封面</div>
                        </div>
                      ))}

                    {activeTab === "all" &&
                      (generating && !generatedCoverUrl ? (
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "60px 20px" }}>
                          <LoadingSpinner />
                          <div style={{ marginTop: "20px", fontSize: "14px", color: "#666" }}>全部内容生成中...</div>
                        </div>
                      ) : generatedCoverUrl ? (
                        <div>
                          <div
                            style={{
                              background: "#f5f5f5",
                              borderRadius: "12px",
                              overflow: "hidden",
                              marginBottom: "12px",
                              maxHeight: "400px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <img
                              src={generatedCoverUrl}
                              alt="生成的封面"
                              style={{
                                width: "100%",
                                maxHeight: "400px",
                                display: "block",
                                objectFit: "contain",
                              }}
                            />
                          </div>
                          <div style={{ fontSize: "12px", color: "#999", textAlign: "center", marginBottom: "12px" }}>已生成：音频、视频、封面</div>
                          <button
                            onClick={() => {
                              window.open(generatedCoverUrl, "_blank")
                            }}
                            style={{
                              width: "100%",
                              padding: "10px 20px",
                              backgroundColor: "#fff",
                              color: "var(--theme-main)",
                              border: "1px solid var(--theme-main)",
                              borderRadius: "50vmin",
                              fontSize: "14px",
                              fontWeight: "500",
                              cursor: "pointer",
                              transition: "all 0.3s",
                            }}
                            onMouseEnter={(e) => {
                              const target = e.target as HTMLButtonElement
                              target.style.backgroundColor = "var(--theme-main)"
                              target.style.color = "#fff"
                            }}
                            onMouseLeave={(e) => {
                              const target = e.target as HTMLButtonElement
                              target.style.backgroundColor = "#fff"
                              target.style.color = "var(--theme-main)"
                            }}
                          >
                            下载封面
                          </button>
                        </div>
                      ) : (
                        <div style={{ textAlign: "center", padding: "40px 20px" }}>
                          <div
                            style={{
                              width: 80,
                              height: 80,
                              background: "#f2f6fa",
                              borderRadius: "16px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginBottom: 16,
                              margin: "0 auto 16px",
                            }}
                          >
                            <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="48.000000" height="48.000000" fill="none">
                              <defs>
                                <image id="image_all" width="200.000000" height="200.000000" xlinkHref={require("../../../images/mp4Default.png")} />
                                <pattern id="pattern_all" width="1.000000" height="1.000000" patternContentUnits="objectBoundingBox">
                                  <use transform="matrix(0.005,0,0,0.005,0,0)" xlinkHref="#image_all" />
                                </pattern>
                              </defs>
                              <rect width="200.000000" height="200.000000" x="0.000000" y="0.000000" fill="url(#pattern_all)" />
                            </svg>
                          </div>
                          <div style={{ fontSize: 16, fontWeight: 500, marginBottom: 8, color: "#666" }}>全部生成</div>
                          <div style={{ fontSize: 14, color: "#999" }}>一键生成音频、视频和封面</div>
                        </div>
                      ))}
                  </div>
                </Spin>

                {/* 生成按钮 */}
                <GenerateButton
                  onClick={async () => {
                    if (activeTab === "ai") {
                      // AI生成tab，直接调用AI生成函数
                      await handleAIGenerate()
                    } else {
                      // 其他tab，先保存内容
                      const saveSuccess = await handleSave(false)
                      if (saveSuccess) {
                        // 保存成功后跳转到view页面，通过地址栏参数唤起对应的弹窗
                        history.replace(`/index/content/${noteData.pid}?open_generate=${activeTab}&tab=${activeTab}`)
                      }
                    }
                  }}
                  disabled={generating || isSaving || aiGenerating || (activeTab === "ai" && !aiQuestion.trim())}
                >
                  {generating || isSaving || aiGenerating
                    ? aiGenerating
                      ? "AI生成中..."
                      : "保存中..."
                    : activeTab === "ai"
                      ? "开始AI生成"
                      : `保存并生成${activeTab === "audio" ? "音频" : activeTab === "video" ? "视频" : activeTab === "cover" ? "封面" : "全部"}`}
                </GenerateButton>
              </RightPanel>
            </div>
          </div>

          {/* 弹窗 */}
          <Modal
            title={activeTab === "audio" ? "选择音频模型" : activeTab === "video" ? "选择视频模型" : "选择模型"}
            open={modalVisible}
            onCancel={() => setModalVisible(false)}
            footer={null}
            width={800}
          >
            {/* 只在需要音频时显示 */}
            {(activeTab === "audio" || activeTab === "all") && (
              <ModalSection>
                <h4>声音模型</h4>
                {soundLoading ? (
                  <div style={{ height: 120, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Spin />
                  </div>
                ) : (
                  <SoundList
                    onWheel={(e) => {
                      // 阻止默认的垂直滚动
                      e.preventDefault()
                      // 将垂直滚轮转换为横向滚动
                      const scrollContainer = e.currentTarget
                      scrollContainer.scrollLeft += e.deltaY
                    }}
                  >
                    {soundList.map((item) => (
                      <SoundItem key={item.id} className={selectedSoundId === item.id ? "selected" : ""} onClick={() => setSelectedSoundId(item.id)}>
                        <SoundInfo>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <div style={{ flex: 1, width: "93px" }}>
                              <SoundTitle>{item.filename || "音频文件"}</SoundTitle>
                              <SoundTime>{item.updatetime}</SoundTime>
                            </div>
                            <ActionButton
                              onClick={(e) => {
                                e.stopPropagation() // 防止触发选择
                                // 播放选中的音频
                                if (audioRef.current) {
                                  if (isPlaying && audioRef.current.src === item.url) {
                                    audioRef.current.pause()
                                    setIsPlaying(false)
                                  } else {
                                    audioRef.current.src = item.url
                                    audioRef.current.play()
                                    setIsPlaying(true)
                                  }
                                }
                              }}
                              style={{
                                padding: "4px 8px",
                                fontSize: "12px",
                                opacity: item.url ? 1 : 0.5,
                                cursor: item.url ? "pointer" : "not-allowed",
                              }}
                              disabled={!item.url}
                            >
                              {isPlaying && audioRef.current?.src === item.url ? <PauseCircleOutlined /> : <PlayCircleOutlined />}
                            </ActionButton>
                          </div>
                        </SoundInfo>
                      </SoundItem>
                    ))}
                    {soundList.length < soundLength && (
                      <SoundLoadMoreButton onClick={() => handleGetSoundList()}>
                        <RightOutlined className="load-more-icon" />
                      </SoundLoadMoreButton>
                    )}
                  </SoundList>
                )}
                <audio
                  ref={audioRef}
                  onEnded={() => setIsPlaying(false)}
                  onError={() => {
                    setIsPlaying(false)
                  }}
                />
                {/* 隐藏原有的soundText显示 */}
                <div style={{ display: "none" }}>
                  <GrayBox>{soundText}</GrayBox>
                </div>
              </ModalSection>
            )}

            {/* 只在需要视频时显示 */}
            {(activeTab === "video" || activeTab === "all") && (
              <ModalSection>
                <h4>视频模型</h4>
                {innerLoading ? (
                  <Spin style={{ height: 270 }} />
                ) : (
                  <VideoList
                    onWheel={(e) => {
                      // 阻止默认的垂直滚动
                      e.preventDefault()
                      // 将垂直滚轮转换为横向滚动
                      const scrollContainer = e.currentTarget
                      scrollContainer.scrollLeft += e.deltaY
                    }}
                  >
                    {contentList.map((item) => (
                      <VideoItem key={item.id} className={selectedVideoId === item.id ? "selected" : ""} onClick={() => setSelectedVideoId(item.id)}>
                        <VideoPlayer controls>
                          <source src={item.url} />
                          您的浏览器不支持视频播放
                        </VideoPlayer>
                        <VideoInfo>
                          <div style={{ float: "left" }}>
                            <VideoTitle>{item.filename}</VideoTitle>
                            <VideoTime>{item.updatetime}</VideoTime>
                          </div>
                        </VideoInfo>
                      </VideoItem>
                    ))}
                    {contentList.length < viewLength && (
                      <LoadMoreButton onClick={() => handleGetContentList()}>
                        <RightOutlined className="load-more-icon" />
                      </LoadMoreButton>
                    )}
                  </VideoList>
                )}
              </ModalSection>
            )}

            <div style={{ textAlign: "center", marginTop: "20px" }}>
              {activeTab === "audio" && (
                <ActionButton
                  onClick={handleGenerateAudio}
                  disabled={!selectedSoundId || generating}
                  style={{
                    opacity: !selectedSoundId || generating ? 0.5 : 1,
                    cursor: !selectedSoundId || generating ? "not-allowed" : "pointer",
                  }}
                >
                  {generating ? "生成中..." : "生成音频"}
                </ActionButton>
              )}
              {activeTab === "video" && (
                <ActionButton
                  onClick={() => {
                    handleGenerateVideo()
                    setModalVisible(false)
                  }}
                  disabled={!selectedVideoId || !selectedSoundId || generating}
                  style={{
                    opacity: !selectedVideoId || !selectedSoundId || generating ? 0.5 : 1,
                    cursor: !selectedVideoId || !selectedSoundId || generating ? "not-allowed" : "pointer",
                  }}
                >
                  {generating ? "生成中..." : "生成视频"}
                </ActionButton>
              )}
              {activeTab === "all" && (
                <ActionButton
                  onClick={handleGenerateAll}
                  disabled={!selectedVideoId || !selectedSoundId || generating}
                  style={{
                    opacity: !selectedVideoId || !selectedSoundId || generating ? 0.5 : 1,
                    cursor: !selectedVideoId || !selectedSoundId || generating ? "not-allowed" : "pointer",
                  }}
                >
                  {generating ? "生成中..." : "全部生成"}
                </ActionButton>
              )}
            </div>
          </Modal>
        </div>
      </GlobalStyle>
    </>
  )
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setLoginBindInfo: (data) => {
      dispatch(setLoginBindInfo(data))
    },
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.login_user_data,
    loginBindInfo: state.loginBindInfo,
  }
}

export default BanUnLogin(Main(connect(mapStateToProps, mapDispatchToProps)(NoteEdit)))
